import React from "react";

export default function PageHeader({ title, description, actions }) {
  return (
    <div className="page-header page-header-actions">
      <div>
        <h1 className="page-header-title">{title}</h1>
        {description ? <p className="page-header-desc">{description}</p> : null}
      </div>
      {actions ? <div className="page-header-actions-right">{actions}</div> : null}
    </div>
  );
}
